import React, { FunctionComponent } from 'react'
import Walkthroughs from '../Cards/WalkthroughHistory'

interface WalkthroughsPanelProps {
  portfolioHomeId: string
}
export const WalkthroughsPanel: FunctionComponent<
  React.PropsWithChildren<WalkthroughsPanelProps>
> = ({ portfolioHomeId }) => <Walkthroughs portfolioHomeId={portfolioHomeId} />
